import { currentApimUrl } from '../utils/baseUrlUtil';
import axiosWithAuth from './AxiosWithAuthService';

let useIntercepters = true;
export const mockHostUrl = 'http://localhost:9010';

export const getMockStorageURL = (env: string) => {
  if (env === 'development') {
    return 'https://carvanaassetsdev.blob.core.windows.net/mycarvana-mock';
  }
  return 'https://carvanaassetstest.blob.core.windows.net/mycarvana-mock';
};

export const mockStorageUrl = getMockStorageURL(process.env.NODE_ENV);

export const formatUrl = (url: string, env: string, useMock?: boolean) => {
  useIntercepters = true;

  if (process.env.USE_MOCK === 'local') {
    return `${mockHostUrl}${url}`;
  }
  if (process.env.USE_MOCK === 'storage' || process.env.NODE_ENV === 'development') {
    const jsonUrl = `${url.concat(url.substring(url.lastIndexOf('/')))}.json`;
    useIntercepters = false;
    return `${mockStorageUrl}${jsonUrl}`;
  }
  return `${process.env.CARVANA_API_HYDRA_BASE_URL}${url}`;
};

export const formatApimUrl = (url: string, env: string) => {
  return `${currentApimUrl(env)}${url}`;
};

/*  POST  */
type PostType = {
  url: string;
  data?: any;
  options?: any;
};

export const postRequest = ({ url, data = {}, options = {} }: PostType) => {
  const endpointUrl = !url?.startsWith('http') ? formatUrl(url, process.env.NODE_ENV) : url;
  return axiosWithAuth(true, options).post(endpointUrl, data);
};

/*  POST  */
export const apimPostRequest = (
  url: string,
  env: string,
  data?: any,
  config?: any,
  appInsightCallback?: (params: any) => void
) => {
  const endpointUrl = formatApimUrl(url, env);
  return axiosWithAuth(true).post(endpointUrl, data, config);
};

export const cancelPostRequest = (
  url: string,
  env: string,
  data?: any,
  config?: any,
  appInsightCallback?: (params: any) => void
) => {
  const endpointUrl = formatUrl(url, env);
  return axiosWithAuth(true).post(endpointUrl, data, config);
};

/*  GET  */
type GetType = {
  url: string;
  isApimUrl?: boolean;
  options?: any;
  headers?: any;
};

export const getRequest = ({ url, isApimUrl = false, options = {}, headers = {} }: GetType) => {
  let endpointUrl;
  const env = process.env.NODE_ENV;

  if (!isApimUrl) {
    endpointUrl = url.startsWith('http') ? url : formatUrl(url, env);
  } else {
    endpointUrl = formatApimUrl(url, env);
  }
  /** With interceptor true, the axios interceptor returns response.data to our APIs.
   * Hence explicitly returning response.data when it's false in line 64. Otherwise
   * it would be response.data.data in the response handler when switching
   * between mock data and api. Refer AxiosWithAuth.js */
  const result: any = {};
  return axiosWithAuth(useIntercepters, options)
    .get(endpointUrl, { headers })
    .then((response: any) => (useIntercepters ? response : response.data))
    .catch((error: any) => {
      result.error = error;
      return result;
    });
};

/*  GET  */
export const getRequestWithConfig = (isApimUrl: boolean = false, url: string, env: string, config = {}) => {
  let endpointUrl: string = url;
  if (!isApimUrl) {
    endpointUrl = formatUrl(url, env);
  }
  /** With interceptor true, the axios interceptor returns response.data to our APIs.
   * Hence explicitly returning response.data when it's false in line 64. Otherwise
   * it would be response.data.data in the response handler when switching
   * between mock data and api. Refer AxiosWithAuth.js */
  const result: any = {};
  return axiosWithAuth(useIntercepters, config)
    .get(endpointUrl)
    .then((response: any) => response)
    .catch((error: any) => {
      result.error = error;
      Promise.reject(result);
    });
};
